import React from "react"

import { FormControl, FormLabel } from "@mui/joy";
import { Controller } from "react-hook-form";
import { List } from "src/mtska-frontend-modules/modules/AudienceSegment/views";
import { useTranslation } from 'react-i18next';
import { useListFiltersAdapter } from "src/mtska-frontend-app-component/utils";
import JSONPretty from 'react-json-pretty';

/** Stable fallback so List selection sync does not see a new [] each render (see List.jsx selectionModel effect). */
const EMPTY_SELECTION_MODEL = []

const InputListAudienceSegment = ({
    control,
    editing,
    name,
    label,
    readonly,
    className = "",
    dataProviderName,
    defaultSelectedValues,
    enableSelection,
    disableMultipleRowSelection,
    hideTableToolbar = false,
    filters,
    relation
}) => {

    const { adaptRelationshipFilters } = useListFiltersAdapter();
    const { t } = useTranslation();
    if (!editing) readonly = true;

    let generalClass = "form-element-control";
    generalClass += (editing) ? " editing" : " reading";
    generalClass += (readonly) ? " readonly" : "";
    return (
        <Controller
            name={name}
            control={control}
            render={({
                field: { onChange, value, name },
                fieldState: { error, invalid },
                formState,
            }) => {

                const rowSelectionExternalListener = (selectionModel) => {
                    onChange(selectionModel);
                }

                filters = adaptRelationshipFilters(filters, relation, formState);

                const resolvedSelectionModel = Array.isArray(value)
                    ? value
                    : (relation.selectionModel != null ? relation.selectionModel : EMPTY_SELECTION_MODEL)

                return (
                    <div className={("form-element list " + className).trim()}>
                        <FormControl error={invalid} className={(error) ? generalClass + " form-element-error" : generalClass}>
                            <FormLabel className="form-element-label" htmlFor={name}>{t(label)}</FormLabel>
                            {/* InputListAudienceSegment
                            <JSONPretty data={filters} className="json-wrapper"/>
                            Fine InputListAudienceSegment */}
                            <List
                                leftButtons={[]}
                                rightButtons={[]}
                                dataProviderName={dataProviderName}
                                title={label}
                                rowSelectionExternalListener={rowSelectionExternalListener}

                                defaultSelectedValues={defaultSelectedValues}
                                enableSelection={enableSelection}
                                disableMultipleRowSelection={disableMultipleRowSelection}

                                className={className}
                                hideTableToolbar={true}
                                hideTableFooter={false}
                                isEmbedded={true}
                                filters={filters}
                                selectionModel={resolvedSelectionModel}
                            />
                        </FormControl>
                    </div>
                )
            }}
        />
    );
};


export default InputListAudienceSegment;
